export default function objectifyByKey(arr, key) {
  if (!Array.isArray(arr)) {
    throw new Error(`objectifyByKey: First argument must be an array, received ${typeof arr}`);
  }
  if (key === undefined || key === null) {
    throw new Error('objectifyByKey: Key parameter is required');
  }
  if (!arr.length) return {};

  const seenKeys = new Set();
  const reducer = (acc, el) => {
    // Use 'in' operator to handle falsy values like 0, '', or false
    if (key in el) {
      const keyValue = el[key];
      // Warn about duplicate keys
      if (seenKeys.has(keyValue)) {
        console.warn(`objectifyByKey: Duplicate key "${keyValue}" found. Later elements will overwrite earlier ones.`);
      }
      seenKeys.add(keyValue);
      return { ...acc, [keyValue]: el };
    }
    return acc;
  };

  return arr.reduce(reducer, {});
}

// eslint-disable-next-line import/no-default-export
// This file needs both default and named exports for backward compatibility
export { objectifyByKey };
